// @ts-strict-ignore
import {appApiUrl, handleJsonRequest} from '../utils';

export enum Compliance {
  GDPR = `gdpr`,
  CCPA = `ccpa`,
}

export enum Status {
  PENDING = `PENDING`,
  RUNNING = `RUNNING`,
  REVOKED = `REVOKED`,
  SUCCESS = `SUCCESS`,
  ERRORED = `ERRORED`,
  EXPIRED = `EXPIRED`,
}

export interface ComplianceJobStatus {
  distinctIds: number[];
  status: Status;
}

export interface ComplianceJobStatusResponse {
  status: string;
  results: any;
}

export enum RequestType {
  USER_DELETION = `User Deletion`,
  DATA_EXPORT = `Data Export`,
}

export enum DisclosureType {
  SOURCES = `SOURCES`,
  CATEGORIES = `CATEGORIES`,
  DATA = `DATA`,
}

export interface ComplianceJob {
  id?: number;
  requestTaskId: string;
  status: Status;
  destinationUrl: string;
  projectId: string;
  distinctIdCount: number;
  dateRequested: Date;
  requestingUser: string;
  compliance: Compliance;
  requestType: RequestType;
  disclosureType: DisclosureType;
}

export async function fetchComplianceJobApi(
  trackingId: string,
  projectToken: string,
  gdprApiToken: string,
  requestType: RequestType,
  method: string,
): Promise<Response> {
  const GDPR_RETRIEVAL_ENDPOINT = appApiUrl(`data-retrievals/v3.0/${trackingId}?token=${projectToken}`);
  const GDPR_DELETION_ENDPOINT = appApiUrl(`data-deletions/v3.0/${trackingId}?token=${projectToken}`);
  const typeToEndpoint = {
    [RequestType.DATA_EXPORT]: GDPR_RETRIEVAL_ENDPOINT,
    [RequestType.USER_DELETION]: GDPR_DELETION_ENDPOINT,
  };
  const url = typeToEndpoint[requestType];
  return fetch(url, {
    headers: {
      Authorization: `Bearer ${gdprApiToken}`,
    },
    method,
  });
}

export async function fetchComplianceJobStatus(
  trackingId: string,
  projectToken: string,
  gdprApiToken: string,
  requestType: RequestType,
): Promise<ComplianceJobStatus> {
  const response: ComplianceJobStatusResponse = await handleJsonRequest(
    fetchComplianceJobApi(trackingId, projectToken, gdprApiToken, requestType, `GET`),
  );

  return {
    distinctIds: response.results.distinct_ids,
    status: response.results.status,
  };
}

export async function cancelComplianceJob(
  trackingId: string,
  projectToken: string,
  gdprApiToken: string,
): Promise<Response> {
  return fetchComplianceJobApi(trackingId, projectToken, gdprApiToken, RequestType.USER_DELETION, `DELETE`);
}
